import {states} from "../Constants/locations";
import axios from "axios";

export const autocompleteCurrentPosition = () => {
    const options = {
        timeout: 3000,
        maximumAge: 0
    };
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition((position) => {
            return resolve(position);
        }, () => {
            reject(null);
        }, options);
    });
};

export const getUsState = async (res) => {
    return axios(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${parseFloat(res.coords.latitude)},${parseFloat(res.coords.longitude)}&key=${process.env.REACT_APP_GOOGLE_GEOCODE_KEY}`)
        .then((response: any) => {
            if (response.data.results) {
                const userState = response.data.results[0].address_components.find(({types: [type]}) => type === "administrative_area_level_1")?.short_name;
                const usState = states.find(item => item.value === userState);
                return (usState);
            } else {
                return false;
            }
        });
};
